import { Avatar } from "@chakra-ui/react";

const PALETTE = ["brand.500", "teal.500", "warning.500", "success.600", "danger.500"];

function corDeterministica(name) {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  return PALETTE[Math.abs(hash) % PALETTE.length];
}

export default function AvatarInitials({ name, size = "sm", ...rest }) {
  return (
    <Avatar
      name={name}
      size={size}
      bg={corDeterministica(name || "")}
      color="white"
      fontWeight="semibold"
      {...rest}
    />
  );
}
